import PropTypes from 'prop-types';

import { CartItemPropTypes } from './CartItem.proptypes';

export const CartDefaultProps = {
  discount_classes: [],
  id: null,
  items: [],
  subtotal: null,
};

export const CartPropTypes = {
  discount_classes: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      current_step: PropTypes.shape({
        level: PropTypes.number,
        percentage: PropTypes.number,
      }),
      label: PropTypes.string,
      missing_amount: PropTypes.number,
      next_step: PropTypes.oneOfType([
        PropTypes.shape({
          level: PropTypes.number,
          percentage: PropTypes.number,
        }),
        PropTypes.arrayOf(PropTypes.shape({})),
      ]),
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          discount_amount: PropTypes.number,
          discount_percentage: PropTypes.number,
          level: PropTypes.number,
        }),
      ),
    }),
  ),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  items: PropTypes.arrayOf(PropTypes.shape({ ...CartItemPropTypes })),
  subtotal: PropTypes.number,
};
